import logoinitial from './images/logoinitial.png';
import profile from './images/profileicon.png';
import emailicon from './images/EmailIcon.png';
import greenCross from './images/GreenCross.svg';
import blueCross from './images/BlueCross.svg';
import novarumLogo from './images/novarumLogo.png';
import premierbiotechlogo from './images/Premier_Biotech_Logo.png';
import premierbiotechlogolong from './images/Premier_Biotech_Logo_expand.png';
import pbiologoexpand from './images/pbiologoexpand.png';
import pbiologosmall from './images/pbiologosmall.png';
import ct_scan_large from './images/ct_scan_large.png';
import normalresult from './images/normal_result.png';
import moderateresult from './images/moderate_result.png';
import highresult from './images/high_result.png';
import invalidresult from './images/invalid_result.png';
import apple from './images/silver_apple_logo.png';
import android from './images/android_logo.png';
import reprocessed from './images/reprocessed_logo.png';
import ISOManufactureDate from './images/ISOManufactureDate.png';
import ISOManufacturedBy from './images/ISOManufacturedBy.png';
import good from './images/good.png';
import ok from './images/ok.png';
import bad from './images/bad.png';
import world_map from './images/world_map.png';
import udi from './images/udisymbol.png';

const assets = {
    images: {
        logoinitial,
        profile,
        emailicon,
        greenCross,
        blueCross,
        novarumLogo,
        premierbiotechlogo,
        premierbiotechlogolong,
        pbiologoexpand,
        pbiologosmall,
        ct_scan_large,
        normalresult,
        moderateresult,
        highresult,
        invalidresult,
        apple,
        android,
        reprocessed,
        ISOManufactureDate,
        ISOManufacturedBy,
        good,
        ok,
        bad,
        world_map,
        udi
    },
    actions: {},
    fonts: {}
}

export default assets;
